export default "__VITE_ASSET__EkqjlTlZ__"